import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const MaskLines = ({ lines, className = "", delay = 0.15, as = "h1", testId }) => {
  const Tag = as;
  return (
    <Tag className={className} data-testid={testId}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span
            className="block"
            initial={{ y: "105%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1.1, ease: EASE, delay: delay + i * 0.12 }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};

export const Reveal = ({ children, className = "", delay = 0, y = 28, as = "div", ...rest }) => {
  const M = motion[as];
  return (
    <M
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.12 }}
      transition={{ duration: 0.8, ease: EASE, delay }}
      {...rest}
    >
      {children}
    </M>
  );
};

export const SectionLabel = ({ index, children, light = false }) => (
  <div className={`text-[13px] font-bold uppercase tracking-[0.2em] flex items-center gap-3 ${light ? "text-[var(--lime)]" : "text-[var(--leaf)]"}`}>
    <span className={`inline-block h-[3px] w-8 ${light ? "bg-[var(--lime)]" : "bg-[var(--leaf)]"}`} />
    <span>{children}</span>
  </div>
);
